export const default_second_message_ja: string = `
    名古屋大学大学院情報学研究科情報システム学専攻の修士1年生（M1）です。2026年3月に学部を卒業し、同年4月に大学院に進学しました。\n
    研究テーマはHPC環境向けLLMを用いた汎用自律研究基盤（ARI: Autonomous Research Infrastructure）の構築です。\n
`;

export const default_second_message_en: string = `
    I am a first-year M.S. student in the Graduate School of Informatics (Information Systems) at Nagoya University. I received my B.S. from Nagoya University in March 2026 and enrolled in the M.S. program in April 2026.\n
    My research focuses on building a general-purpose autonomous research infrastructure for HPC environments using LLMs (ARI: Autonomous Research Infrastructure).\n
`;
